import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { API_BASE_URL } from '../../environments/environment';
import moment from 'moment';

@Component({
  selector: 'app-importer',
  templateUrl: './importer.component.html',
  styleUrls: ['./importer.component.less']
})

export class ImporterComponent implements OnInit {

  // csvの内容
  private csv: string = "";

  // ファイルタイプ
  public fileType: string = "";

  // 更新日時
  contractLedgerWorkUpdate: string = "";
  purchaseUpdate: string = "";
  purchaseActualUpdate: string = "";
  sitesUpdate: string = "";
  billingAddressUpdate: string = "";
  paidHolidayUpdate: string = "";

  // ローディング
  public nowSending: boolean = false;

  // ヘッダー
  public headers = new HttpHeaders({
    "X-LoginAccessKey": localStorage.getItem("accessKey")
  });

  constructor(private http: HttpClient) { }

  ngOnInit() {
    this.updateDate();
  }

  /**
   * インポートするファイル選択 イベント
   * @param files 対象ファイル
   */
  public changeListener(files: FileList){
    if(files && files.length > 0) {
      let file : File = files.item(0);
      let reader: FileReader = new FileReader();
      reader.readAsText(file);
      reader.onload = (e) => {
        this.csv = reader.result as string;
      }
    }
  }

  /**
   * インポート ボタンイベント
   * 1分以上かかるものがあるので、結果は待たずに「開始しました」と出す。
   * 終わったかどうかは画面を開き直して最終更新日で確かめる。
   */
  public upload() {
    console.info("upload()");
    console.info(this.fileType);
    this.nowSending = true;

    try {
      let httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'plain/csv',
          "X-LoginAccessKey": localStorage.getItem("accessKey")
        })
      };
      this.http.post(
        API_BASE_URL + '/api/v1/files/' + this.fileType,
        this.csv,
        httpOptions
      )
      .subscribe(res => {
        console.info(res);
      },
      error => {
        console.info(error);
      });
    } catch (e) {
    }

    this.nowSending = false;
    alert("インポートを開始しました。");
    this.updateDate();
}

  /**
   * 更新日時取得
   */
  updateDate() {
    this.http.get(
      API_BASE_URL + '/api/v1/files/importState',
      {headers: this.headers}
    )
    .subscribe(res => {
      let data = res as any;
      if (data != null && data.importState.length > 0) {

        data.importState.forEach(state => {
          if (state.fileType == 'contractLedgerWork') {
            this.contractLedgerWorkUpdate = this.getUpdateDisp(state.state, state.processingDatetime);
          } else if (state.fileType == 'purchase') {
            this.purchaseUpdate = this.getUpdateDisp(state.state, state.processingDatetime);
          } else if (state.fileType == 'purchaseActual') {
            this.purchaseActualUpdate = this.getUpdateDisp(state.state, state.processingDatetime);
          } else if (state.fileType == 'sites') {
            this.sitesUpdate = this.getUpdateDisp(state.state, state.processingDatetime);
          } else if (state.fileType == 'billingAddress') {
            this.billingAddressUpdate = this.getUpdateDisp(state.state, state.processingDatetime);
          } else if (state.fileType == 'paidHoliday') {
            this.paidHolidayUpdate = this.getUpdateDisp(state.state, state.processingDatetime);
          }
        });
      }
    },
    error => {
      alert("認証に失敗しました");
    });
  }

  /**
   * 更新表示内容取得
   * @param state
   * @param processingDatetime
   */
  getUpdateDisp(state, processingDatetime) {
    let dt = moment(processingDatetime).format('YYYY-MM-DD HH:mm:ss')
    switch (state) {
      case 1:
        return '実行中';
      case 5:
        return dt + ' (エラー発生)';
      default:
        return dt;
    }
  }
}
